<template>
    <div class="row left-content">
        <b-card
            v-if="clients"
            title="Clients"
        >
            <router-link class="btn btn-secondary mb-2" :to="{name: 'admin.wallet.wallet_project'}">
                Project Wallets
            </router-link>
            <div>
                <b-form inline>
                    <b-form-input
                        v-model="form.id"
                        type="text"
                        placeholder="ID"
                    ></b-form-input>
                    <b-form-select
                        v-model="form.project"
                        :options="projects"
                    >
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>Project</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-input
                        v-model="form.firstName"
                        type="text"
                        placeholder="First Name"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.lastName"
                        type="text"
                        placeholder="Last Name"
                    ></b-form-input>
                    <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder="Email"
                    ></b-form-input>

                    <b-button variant="primary" type="submit" @click.prevent.stop="search">Search</b-button>
                </b-form>
            </div>
            <table class="table table-bordered table-striped mt-4">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Project</th>
                    <th>Created At</th>
                    <th>Name</th>
                    <th>Type</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="client in clients" :key="client.id">
                    <td>
                        <router-link :to="{name: 'admin.wallet.client.view', params: { id: client.id }}">
                            {{ client.id }}
                        </router-link>
                    </td>
                    <td>{{ client.project_title }}</td>
                    <td>{{ formatedDate(client.date) }}</td>
                    <td>{{ client.name + '(' + client.email + ')' }}</td>
                    <td>
                        <b-badge class="mr-1" variant="primary" v-if="client.payment_customer_id">Demand</b-badge>
                        <b-badge variant="success" v-if="client.transfer_customer_id">Supplier</b-badge>
                    </td>
                </tr>
                </tbody>
            </table>
            <b-pagination
                v-if="paginator.total / paginator.perPage > 1"
                :value="page"
                :total-rows="paginator.total"
                :per-page="paginator.perPage"
                @change="change($event)"
            ></b-pagination>
        </b-card>

    </div>
</template>

<script>
export default {
    name: "List",
    props: {
        'page': {
            'default': 1
        }
    },
    data() {
        return {
            clients: [],
            paginator: [],
            form: {
                email: null,
                firstName: null,
                lastName: null,
                id: null,
                project: null
            }
        }
    },
    computed: {
        projects() {
            return this.$store.state.projects;
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.$router.push({ name: 'admin.wallet.client', params: { page: event }, query: { form: this.form } });
        },
        getClients(page) {
            window.axios.get('/admin/wallet/client/index', {params: {...{page: page}, ...this.form}})
                .then(response => {
                        this.clients = response.data.clients;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
        search() {
            this.getClients(this.page);
        }
    },
    mounted() {
        if (this.$router.currentRoute.query.form !== undefined) {
            this.form = this.$router.currentRoute.query.form;
        }
        this.getClients(this.page);
        this.$store.dispatch('getProjectsList');
    }
}
</script>